import apiClient from './client'
import { STORAGE_KEYS } from '../utils/constants'
import { collectLoginContext } from '../utils/loginContext'

export const authAPI = {
  /**
   * Login merchant
   */
  login: async (email, password) => {
    let loginContext = {}
    try {
      loginContext = await collectLoginContext()
    } catch {
      loginContext = {}
    }

    const response = await apiClient.post('/login', {
      email,
      password,
      ...loginContext,
    })
    const { token, lastLogin, branding, masterId } = response.data
    
    // Store token and merchant ID
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token)
    if (response.data.merchantId) {
      localStorage.setItem(STORAGE_KEYS.MERCHANT_ID, response.data.merchantId)
    }
    if (masterId != null) {
      localStorage.setItem('merchantMasterId', String(masterId))
    }
    if (branding?.slug) {
      localStorage.setItem('brandSlug', branding.slug)
    }
    
    return { token, lastLogin, branding, masterId }
  },

  /**
   * Logout merchant
   */
  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.MERCHANT_ID)
    localStorage.removeItem('merchantMasterId')
    localStorage.removeItem('brandSlug')
  },

  /**
   * Check if user is authenticated
   */
  isAuthenticated: () => {
    return !!localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
  },

  /**
   * Get stored token
   */
  getToken: () => {
    return localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
  },
}
